import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import { Helmet } from "react-helmet";
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'

function Cshistory(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
      
      
<Sides/>
<Helmet>
 
<title>C# History tutorial For Beginners</title>
<meta name="description" content="C# History tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like c# tutorial, c# tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# history,learn code,Learn Programming Tutuorial For Begineers,Learn Programming Online " />
<link rel="canonical" href="https://www.codeexampler.com/csharp-history" />
</Helmet>
<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Csharp(C#) History</h1>
    <div className="first">
    <a href="/csharp-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-introduction">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, C# is the first of the programming languages Planned for the Common Language Infrastructure (CLI).<br/>
2, C#  programming languages were designed by Anders Hejlsberg<br/>
3, C# 8.0 Version Stable Release on 23/09/2019 is the first major specifically targets on .NET Core<br/>
4, Csharp 9.0 Version Preview Release on 20/05/2020 
</p>

    <Table  striped bordered hover responsive variant="dark" className="m-4">
  <thead>
    <tr>
      <th></th>
      <th colSpan="1">c# Versions</th>
      <th >c# Versions release date</th>
   
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>C# Version 1.0</td>
      <td>2002</td>
    </tr>
    <tr>
      <td>2</td>
      <td>C# Version 2.0</td>
      <td>2005</td>
     
    </tr>
    <tr>
      <td>3</td>
      <td>C# Version  3.0</td>
      <td>2008</td>
     
    </tr>
    <tr>
      <td>4</td>
      <td>C# Version 4.0</td>
      <td>2010</td>
     
    </tr>

    <tr>
      <td>5</td>
      <td>C# Version 5.0</td>
      <td>2012</td>
     
    </tr>

    <tr>
      <td>6</td>
      <td>C# Version 6.0</td>
      <td>2015</td>
     
    </tr>

    <tr>
      <td>7</td>
      <td>C# Version 7.0</td>
      <td>2017</td>
     
    </tr>


    <tr>
      <td>8</td>
      <td>C# Version 8.0 Present</td>
      <td> 23/09/2019</td>
     
    </tr>

    <tr>
      <td>9</td>
      <td>C# Version 9.0 Preview</td>
      <td> 20/05/2020</td>
     
    </tr>


  </tbody>
</Table>



  <h1 className="mt-5">  </h1>
  <div className="back">
  <a href="/csharp-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-introduction">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Cshistory;